import clsx from "clsx";
import { useState } from "react";
import { GameEvent, UNIT_ATTACK_TYPE } from "../../../../../../types/project";
import styles from "./EventQueuePanel.module.scss";

export default function EventQueuePanel() {
  const [eventQueuePanelVisible, setEventQueuePanelVisible] = useState(true);

  const events: GameEvent[] = [
    {
      triggers: [
        {
          key: "timer",
          label: "Timer",
          comparitor: "=",
          amount: 30,
        },
      ],
      actions: [
        {
          units: [
            {
              unit: {
                projectId: "123",
                id: "23",
                name: "Archers",
                texture: "test.png",
                hp: 12,
                attack: 15,
                defense: 15,
                attackType: UNIT_ATTACK_TYPE.RANGED,
                weaknesses: [UNIT_ATTACK_TYPE.MELEE],
                resourcesCollectable: ["tasf"],
                buildingsBuildable: ["wer"],
                type: "unit",
              },
              id: "army_unit_1",
              count: 100,
            },
          ],
          label: "Army Attack",
          type: "army_attack",
          id: "action_1",
        },
      ],
    },
    {
      triggers: [
        {
          key: "timer",
          label: "Timer",
          comparitor: "=",
          amount: 30,
        },
      ],
      actions: [
        {
          units: [
            {
              unit: {
                projectId: "123",
                id: "23",
                name: "Archers",
                texture: "test.png",
                hp: 12,
                attack: 15,
                defense: 15,
                attackType: UNIT_ATTACK_TYPE.RANGED,
                weaknesses: [UNIT_ATTACK_TYPE.MELEE],
                resourcesCollectable: ["tasf"],
                buildingsBuildable: ["wer"],
                type: "unit",
              },
              id: "army_unit_1",
              count: 100,
            },
          ],
          label: "Army Attack",
          type: "army_attack",
          id: "action_1",
        },
      ],
    },
  ];

  return (
    <div
      className={clsx("panel", "panel-event-queue", {
        active: eventQueuePanelVisible,
      })}
    >
      <div
        className={clsx(
          "toggle-visibility-button",
          "panel-event-query-visibility-button",
          {
            active: eventQueuePanelVisible,
          }
        )}
        onClick={() => {
          setEventQueuePanelVisible((current) => !current);
        }}
      >
        <img
          src="ui/toggle-panel.svg"
          className={clsx("toggle-visibility-icon", "queue", {
            active: eventQueuePanelVisible,
          })}
        />
      </div>
      <div className={clsx(styles.panelContents)}>
        <div className={clsx(styles.heading)}>Event Queue</div>
        {events.map((event) => {
          return (
            <div className={styles.eventWrapper}>
              <div className={styles.eventTriggerWrapper}>
                {event.triggers.map((trigger) => {
                  return (
                    <div>
                      {trigger.key} | {trigger.label} | {trigger.amount}
                    </div>
                  );
                })}
              </div>
              <div className={styles.eventActionsWrapper}>
                {event.actions.map((action) => {
                  return (
                    <div className={styles.eventAction}>
                      <div className={styles.eventActionHeading}>
                        {action.label}
                      </div>
                      <div className={styles.eventActionDetails}>
                        {action.type === "army_attack" && (
                          <>
                            {action.units.map((armyUnit) => (
                              <div
                                className={styles.eventActionDetailArmyPill}
                                key={armyUnit.id}
                              >
                                {armyUnit.count} {armyUnit.unit.name}
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}

                <div className={styles.eventActionCreateButton}>ADD ACTION</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
